import React from "react";
import styled from "styled-components";

import { Button } from "@/components/Form";
import { IThemeProps } from "@/styles";
import { HEXtoRGBA } from "@/styles/helper";
import { moveUpAndFadeIn } from "@/styles/Mixins";
import Markdown from "@/utils/markdown";

export type IntroProps = {
  label: string;
  text: string;
  onButtonClick?: () => void;
  hideButton?: boolean;
  hasBackgroundImage?: boolean;
};

export const Intro: React.FC<IntroProps> = ({
  label,
  text,
  onButtonClick,
  hideButton,
  hasBackgroundImage,
}) => (
  <React.Fragment>
    <IntroBox hasBackgroundImage={hasBackgroundImage}>
      <IntroBoxText dangerouslySetInnerHTML={{ __html: Markdown(text) }} />
      {!hideButton && (
        <IntroBoxButton>
          <Button data-qa="intro:btn" onClick={onButtonClick}>
            {label}
          </Button>
        </IntroBoxButton>
      )}
    </IntroBox>
  </React.Fragment>
);

const IntroBox = styled.div<IThemeProps<{ hasBackgroundImage?: boolean }>>`
  flex: none;
  width: 96%;
  color: ${(props) => props.theme.colors.black};
  text-align: center;
  ${(props) =>
    (props.theme.thesis.hasIntroBackground || props.hasBackgroundImage) &&
    `background-color: ${
      props.theme.thesis.hasTransparency
        ? HEXtoRGBA(props.theme.colors.white, 0.9)
        : props.theme.colors.white
    };
        box-shadow: ${props.theme.shadows.s400};`}
  padding: ${(props) => props.theme.spacing.desktop.s500}px;
  max-width: 500px;
  margin: ${(props) => props.theme.spacing.desktop.s500}px auto;
  border-radius: ${(props) => props.theme.borders.borderRadius};
  animation: ${moveUpAndFadeIn({ size: "30px" })} 250ms linear;
`;

const IntroBoxText = styled.div<IThemeProps>`
  font-size: ${(props) => props.theme.typography.h600};
  @media ${(props) => props.theme.breakpoints.mobile} {
    font-size: ${(props) => props.theme.typography.h400};
  }
`;

const IntroBoxButton = styled.div<IThemeProps>`
  margin-top: ${(props) => props.theme.spacing.desktop.s500}px;
  text-align: center;
  min-width: 90%;
`;
